import {createSelector, sortBy, keyBy, groupBy, moment, map, lowerCase} from 'helpers';
import {createdDate} from 'store/common';

export const list = createSelector(
  state => state.collaborators,
  users => {
    users = map(users, user => ({
      ...user,
      invitable: !user.lastInvited || moment().unix() - user.lastInvited > 60*60,
    }));
    users = sortBy(users, createdDate);
    return {
      ...groupBy([...users].reverse(), user => lowerCase(user.status)),
      byId: keyBy(users, 'id')
    }
  }
);
